import Vue from "vue";

export const store = Vue.observable({
  userAuthToken: '',
  userAuthCode: 0,
  settingsDesktopTimeout: 0,
  settingsBSAUNumber: '',
  settingsSAPSupportEmail: '',
  settingsSAPSupportPhone: '',
  mupBasket: {}
});

export const storeController = {
    setUserAuthToken(token) {
      store.userAuthToken = token;
    },
    setDesktopTimeout(timeoutValue) {
      store.settingsDesktopTimeout = timeoutValue;
    },
    setBSAUNumber(bsauValue) {
      store.settingsBSAUNumber = bsauValue;
    },
    setSAPSupportEmail(sapEmailValue) {
      store.settingsSAPSupportEmail = sapEmailValue;
    },
    setSAPSupportPhone(sapPhoneValue) {
      store.settingsSAPSupportPhone = sapPhoneValue;
    },
    setMUPBasket(basket) {
      store.mupBasket = basket;
      localStorage.setItem('_pp_order', JSON.stringify(basket));
    }
};